import { ArrowRight, IndianRupee, ShieldCheck, Home } from "lucide-react";

export const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="section-pad grain-bg"
    >
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#FEF3C7] border border-[#F59E0B]/30">
            <span className="h-2 w-2 rounded-full bg-[#F59E0B]" />
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#92400E]">
              Home Business Program 2026
            </span>
          </div>

          <h1 className="font-display mt-6 text-5xl sm:text-6xl lg:text-7xl font-black leading-[0.95] tracking-tighter text-[#064E3B]">
            Start from home.<br />
            Earn <span className="text-[#C2410C]">₹5,000 – ₹10,000</span><br />
            every month.
          </h1>

          <p className="mt-6 text-lg text-[#44403C] max-w-xl leading-relaxed">
            Join <b>5GB Corporation</b>'s home-based distributor network. Sell trusted home care
            essentials — liquid detergent, herbal shampoo, handwash and more — to your neighbourhood
            with wholesale margins as high as <b>50%</b>.
          </p>

          <div className="mt-8 flex flex-wrap gap-4">
            <a href="#register" data-testid="hero-cta-register" className="pill-btn pill-btn-primary">
              Register free <ArrowRight className="h-4 w-4" />
            </a>
            <a href="#calculator" data-testid="hero-cta-calculator" className="pill-btn pill-btn-ghost">
              Calculate my earnings
            </a>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4 max-w-lg">
            {[
              { icon: Home, label: "Work from home" },
              { icon: IndianRupee, label: "Zero franchise fee" },
              { icon: ShieldCheck, label: "Trusted products" },
            ].map((it) => (
              <div key={it.label} className="flex flex-col items-start gap-1.5">
                <it.icon className="h-5 w-5 text-[#C2410C]" />
                <span className="text-xs sm:text-sm font-semibold text-[#1C1917]">{it.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -inset-3 bg-[#F59E0B] rounded-[2rem] rotate-2" />
            <img
              src="https://images.unsplash.com/photo-1758874384556-cc2b9dcbb6e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHx3b21hbiUyMHNtaWxpbmclMjByZWxheGVkJTIwd29ya2luZyUyMGZyb20lMjBob21lfGVufDB8fHx8MTc4NDI0MjQ2OXww&ixlib=rb-4.1.0&q=85"
              alt="Woman running her home business"
              className="relative rounded-[2rem] w-full h-[480px] object-cover border-4 border-white shadow-xl"
              data-testid="hero-image"
            />
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-5 shadow-xl border border-[#E7E5E4] max-w-[220px]">
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#C2410C]">Live earnings</div>
              <div className="font-display text-3xl font-black text-[#064E3B] mt-1">₹8,420</div>
              <div className="text-xs text-[#57534E] mt-1">Priya · Jaipur · this month</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
